<ng-container>
  <div class="duties-payment-container">
    <span class="duties-payment-container__header">
      {{ "LABELS.DUTIES_PAYMENT_TYPE" | translate | uppercase }}

      <span class="d-lg-none">
        <app-hint-tooltip-icon [hint]="'LABELS.DUTIES_PAYMENT_DESCRIPTION' | translate"></app-hint-tooltip-icon>
      </span>
    </span>
    <div class="d-flex">
      <div
        class="duties-payment-container__form pl-0 pr-0"
        [ngClass]="{ 'col-12 col-lg-8': isShowDescription, 'col-12': !isShowDescription }"
      >
        <span class="duties-payment-container__question">{{ "COMPANY.ACH_ACCOUNT_APPROVAL_BLOCK.QUESTION" | translate }}</span>

        <div class="duties-payment-container__radio">
          <div
            class="card card-step duties-payment-type"
            [ngClass]="{
              'is-selected': formGroup?.get('achIsProvided').value === false
            }"
          >
            <div class="card-header">
              <app-radio-button
                [id]="'achIsProvided-no'"
                [value]="false"
                [name]="'achIsProvided'"
                [control]="formGroup?.get('achIsProvided')"
                [label]="'LABELS.NO' | translate"
              ></app-radio-button>
            </div>
            <div class="card-body px-3">
              <span [innerHTML]="'COMPANY.ACH_ACCOUNT_APPROVAL_BLOCK.HINT_NO' | translate"></span>
            </div>
          </div>

          <div
            class="card card-step duties-payment-type"
            [ngClass]="{
              'is-selected': formGroup?.get('achIsProvided').value
            }"
          >
            <div class="card-header">
              <app-radio-button
                [id]="'achIsProvided-yes'"
                [value]="true"
                [name]="'achIsProvided'"
                [control]="formGroup?.get('achIsProvided')"
                [label]="'LABELS.YES' | translate"
              ></app-radio-button>
            </div>
            <div class="card-body px-3">
              <span [innerHTML]="'COMPANY.ACH_ACCOUNT_APPROVAL_BLOCK.HINT_YES' | translate"></span>
            </div>
          </div>
        </div>

        <div class="d-flex">
          <div *ngIf="formGroup?.get('achIsProvided').value" class="col-12 pr-0 pl-0">
            <div class="duties-payment-container__agreement custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                id="authorizationAgreementAccepted"
                [formControl]="formGroup.get('authorizationAgreementAccepted')"
              />
              <label class="custom-control-label" for="authorizationAgreementAccepted">
                {{ "COMPANY.AUTHORIZATION_AGREEMENT_ACCEPTED" | translate }}
              </label>
            </div>

            <div id="control-payerUnitNumber">
              <app-control-wrapper
                [isShowHelper]="true"
                [helper]="'FORM_HELPER.PAYER_UNIT_NUMBER' | translate"
                [control]="formGroup.get('payerUnitNumber')"
                [errors]="payerUnitNumberErrors"
              >
                <label for="payerUnitNumber" control-label>
                  {{ "COMPANY.PUN_DESCRIPTION" | translate }}
                </label>
                <input
                  type="text"
                  [formControl]="formGroup.get('payerUnitNumber')"
                  class="form-control"
                  id="payerUnitNumber"
                  name="payerUnitNumber"
                  [dropSpecialCharacters]="false"
                  [mask]="'0{6}'"
                  [appMaskErrorTooltip]="'MASK_ERROR.ONLY_DIGITS' | translate"
                  [maxMaskLength]="6"
                  [placeholder]="'FORM_PLACEHOLDER.NNNNNN' | translate"
                  control-wrapper
                />
              </app-control-wrapper>
            </div>

            <div class="duties-payment-container__uploader">
              <document-upload-desktop
                [id]="'pun-document'"
                [attachmentName]="'COMPANY.ACH_ACCOUNT_APPROVAL' | translate"
                [attachmentHint]="'COMPANY.ACH_ACCOUNT_APPROVAL_ATTACHMENT' | translate"
                [footerHint]="'LABELS.DRAG_N_DROP_FOR_UPLOAD_BROWSE_HIGHLIGHTED'"
                [uploadedDocument]="punDocument"
                [canUploadDocuments]="true"
                [canRemoveDocuments]="true"
                [isLoading]="isLoadingCompanyPun"
                [isShowOptionalTag]="false"
                [isShowFooter]="false"
                [isRequired]="true"
                [isStretched]="true"
                [isDividedLayout]="true"
                [isShowLoader]="false"
                [isShowNormalAddIcon]="true"
                (upload)="uploadDocument.emit($event)"
                (remove)="deleteDocument.emit($event)"
                (stateUpdate)="updateDocumentState.emit($event)"
              ></document-upload-desktop>
            </div>
          </div>

          <div
            class="d-none d-lg-block"
            [ngClass]="{ 'col-12 col-lg-6': formGroup?.get('achIsProvided').value }"
            *ngIf="formGroup?.get('achIsProvided').value"
          >
            <div class="duties-payment-container-description">
              <span [innerHTML]="'LABELS.PAYER_UNIT_NUMBER_DESCRIPTION' | translate"></span>
            </div>
          </div>
        </div>

        <div *ngIf="!formGroup?.get('achIsProvided').value" class="col-12 pr-0 pl-0 duties-payment-container__description">
          <span>
            {{ "COMPANY.DUTIES_PAYMENT_TYPE_DESCRIPTION" | translate }}
            <a href="https://www.cbp.gov/document/forms/form-400-ach-application" target="_blank">
              {{ "LABELS.APPLY_HERE" | translate }}
            </a>
          </span>
        </div>
      </div>
      <div class="d-none d-lg-block" [ngClass]="{ 'col-12 col-lg-4': isShowDescription }" *ngIf="isShowDescription">
        <div class="duties-payment-container-description">
          <span [innerHTML]="'LABELS.DUTIES_PAYMENT_DESCRIPTION' | translate"></span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
